// import { useStrapiConstants } from "../../../hooks/useStrapiConstants";
import ReactMarkdown from 'react-markdown';
import { useStrapiConstants } from "../../../contexts/StrapiConstantsContext";
import Loading from "../../../components/common/Loading";
import { getMediaURL } from "../../../utils/helpers";
const AboutUs = () => {
    const { loaded, homePage, contactPage } = useStrapiConstants();

    if (!loaded) return <Loading />;
    const coverUrl = getMediaURL(homePage.cover);
    return (
        <>
            <hr className="border-none h-0.5 bg-gray-300 m-0" />

            <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-10 lg:py-10">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-10">

                    {/* Text Section */}
                    <div className="order-1 lg:order-1 flex flex-col justify-center">
                        <div className="bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] rounded-xl p-6 sm:p-8 md:p-10 lg:p-12 shadow-lg hover:shadow-2xl transition-all duration-500 hover:scale-[1.02] group">
                            <h2 className="text-white text-2xl sm:text-3xl md:text-4xl font-bold mb-4 md:mb-6 group-hover:translate-x-2 transition-transform duration-300">
                                {homePage.aboutus}
                            </h2>
                            <div className="text-white text-base sm:text-lg md:text-xl leading-relaxed space-y-4">
                                <div className="opacity-90 group-hover:opacity-100 transition-opacity duration-300">
                                    <ReactMarkdown>{homePage.description}</ReactMarkdown>
                                </div>
                            </div>
                            <div className="mt-6 h-1 w-0 group-hover:w-full bg-white/30 rounded-full transition-all duration-700"></div>
                        </div>
                    </div>

                    {/* Image Section */}
                    <div className="order-2 lg:order-2">
                        <a
                            href={contactPage.addressURL}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <div
                                className="relative w-full h-72 sm:h-80 md:h-96 lg:h-full min-h-[400px] rounded-xl bg-cover bg-center shadow-lg overflow-hidden group cursor-pointer hover:shadow-2xl transition-all duration-500"
                                style={{ backgroundImage: `url(${coverUrl})` }}
                                role="img"
                                aria-label="ESAM konumu - Haliç Unkapı Köprüsü"
                            >
                                <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a8a]/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                                <div
                                    className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                                    style={{ backgroundImage: `url(${coverUrl})` }}
                                ></div>

                                <div className="absolute top-4 right-4 w-16 h-16 border-t-4 border-r-4 border-white/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                                <div className="absolute bottom-4 left-4 w-16 h-16 border-b-4 border-l-4 border-white/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            </div>
                        </a>
                    </div>

                </div>
            </div>

            <hr className="border-none h-0.5 bg-gray-300 m-0" />
        </>
    );
};

export default AboutUs;